module.exports = __webpack_public_path__ + "static/media/image-1.54e014e8.png";